import { Button, Link } from 'components/common';
import cn from 'classnames';

interface ButtonActionProps {
  href?: string;
  onClick?: () => void;
  label: React.ReactNode;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'secondary';
  isLoading?: boolean;
  className?: string;
}

const ButtonAction = ({
  href,
  onClick,
  label,
  variant = 'contained',
  color = 'primary',
  isLoading,
  className,
}: ButtonActionProps) => {
  if (!href && !onClick) return null;

  if (href) {
    return (
      <Link to={href} className={className}>
        <Button
          variant={variant}
          color={color}
          disabled={isLoading}
          loading={isLoading}
          className="tw-uppercase tw-min-w-[90px] md:tw-min-w-[130px] lg:tw-min-w-[180px] md:tw-py-[0.95rem] md:tw-px-[1.5rem] lg:tw-py-[1.15rem] tw-text-[1.2rem] md:tw-text-[1.3rem] lg:tw-text-[1.4rem]"
        >
          <>{label}</>
        </Button>
      </Link>
    );
  }

  return (
    <Button
      variant={variant}
      color={color}
      disabled={isLoading}
      loading={isLoading}
      onClick={onClick}
      className={cn(
        'tw-uppercase tw-min-w-[90px] md:tw-min-w-[130px] lg:tw-min-w-[180px] md:tw-py-[0.95rem] md:tw-px-[1.5rem] lg:tw-py-[1.15rem] tw-text-[1.2rem] md:tw-text-[1.3rem] lg:tw-text-[1.4rem]',
        className,
      )}
    >
      <>{label}</>
    </Button>
  );
};

export default ButtonAction;
